import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import firebase from '../../Firebase/firebase'
import './SideNavBar.css'
// Import SideNav elements
import SideNav, { NavItem, NavText, NavIcon } from '@trendmicro/react-sidenav'
// Import CSS required for formatting SideNav
import '@trendmicro/react-sidenav/dist/react-sidenav.css'
const SideNavBar = (props) => {

    const [isAdmin, setisAdmin] = useState(false)

    return (
        <div>
            <SideNav style={{ position: 'fixed', backgroundColor: '#1e88e5' }}
                onSelect={(selected) => {
                    if (selected === 'logOut') {
                        sessionStorage.removeItem('entry')
                        localStorage.removeItem('accessToken')
                        localStorage.removeItem('userid')
                        firebase.logout()
                    }
                    else if (selected === 'prevScreen') {
                        props.history.push(sessionStorage.getItem('prevScreen'))
                    }
                    else {
                        console.log(props)
                        const toLoc = "/" + selected
                        if (props.history.location.pathname !== toLoc) {
                            props.history.push(toLoc)
                        }
                    }
                }}
            >
                <SideNav.Toggle />
                <SideNav.Nav>
                    <NavItem disabled>
                        <NavIcon>
                            <i style={{ color: '#FFFFFF', fontSize: '150%' }} className="fa fa-user"></i>
                        </NavIcon>
                        <NavText>
                            <b>{localStorage.getItem('userid')}</b>
                        </NavText>
                    </NavItem>
                    <hr></hr>
                    <NavItem eventKey='prevScreen'>
                        <NavIcon>
                            <i style={{ color: '#FFFFFF', fontSize: '150%' }} className="fa fa-arrow-left"></i>
                        </NavIcon>
                        <NavText style={{ color: '#FFFFFF' }} >
                            Previous Screen
                        </NavText>
                    </NavItem>
                    <NavItem eventKey="user_details">
                        <NavIcon>
                            <i style={{ color: '#FFFFFF', fontSize: '150%' }} className="fa fa-edit"></i>
                        </NavIcon>
                        <NavText style={{ color: '#FFFFFF' }} >
                            Clean New File
                        </NavText>
                    </NavItem>
                    <NavItem eventKey="summaryScreen">
                        <NavIcon >
                            <i style={{ color: '#FFFFFF', fontSize: '150%' }} className="fa fa-file-excel-o"></i>
                        </NavIcon>
                        <NavText style={{ color: '#FFFFFF' }} >
                            Summary
                        </NavText>
                    </NavItem>
                    <NavItem eventKey="dataUploadSection">
                        <NavIcon >
                            <i style={{ color: '#FFFFFF', fontSize: '150%' }} className="fa fa-upload"></i>
                        </NavIcon>
                        <NavText style={{ color: '#FFFFFF' }} >
                            Branch/Lane Data upload
                        </NavText>
                    </NavItem>
                    <NavItem eventKey="logOut">
                        <NavIcon >
                            <i style={{ color: '#FFFFFF', fontSize: '150%' }} className="fa fa-power-off"></i>
                        </NavIcon>
                        <NavText style={{ color: '#FFFFFF' }} >
                            Log Out
                        </NavText>
                    </NavItem>
                </SideNav.Nav>
            </SideNav>
        </div>
    )
}

export default withRouter(SideNavBar)
